// ---------------------------------------------------------------------------
// Rascunho da compra de fichas (só o aparelho, sessionStorage).
//
// Guarda, por evento, o que a pessoa já escolheu: a quantidade de cada ficha
// e o nome/WhatsApp digitados na janela "Finalizar pedido". Assim, se ela
// voltar para a vitrine ou fechar a janela sem querer, nada se perde.
// Some sozinho quando o pedido é criado com sucesso.
// ---------------------------------------------------------------------------

export interface RascunhoFichas {
  qtd: Record<number, number>;
  nome: string;
  whatsapp: string;
}

const VAZIO: RascunhoFichas = { qtd: {}, nome: '', whatsapp: '' };

export function chaveRascunho(eventoId: number | string): string {
  return `seliga:fichas:${eventoId}`;
}

export function lerRascunho(eventoId: number | string): RascunhoFichas {
  try {
    const cru = sessionStorage.getItem(chaveRascunho(eventoId));
    if (!cru) return { ...VAZIO, qtd: {} };
    const dados = JSON.parse(cru) as Partial<RascunhoFichas> | null;
    if (!dados || typeof dados !== 'object') return { ...VAZIO, qtd: {} };

    const qtd: Record<number, number> = {};
    const origem = (dados.qtd ?? {}) as Record<string, unknown>;
    Object.keys(origem).forEach((k) => {
      const id = Number(k);
      const n = Number(origem[k]);
      if (Number.isFinite(id) && Number.isFinite(n) && n > 0) qtd[id] = Math.floor(n);
    });

    return {
      qtd,
      nome: typeof dados.nome === 'string' ? dados.nome : '',
      whatsapp: typeof dados.whatsapp === 'string' ? dados.whatsapp : '',
    };
  } catch {
    return { ...VAZIO, qtd: {} };
  }
}

function gravar(eventoId: number | string, dados: RascunhoFichas): void {
  try {
    sessionStorage.setItem(chaveRascunho(eventoId), JSON.stringify(dados));
  } catch {
    // armazenamento indisponível: segue sem rascunho
  }
}

/** Quantidades escolhidas (grava a cada toque em −/+). */
export function guardarQuantidades(
  eventoId: number | string,
  carrinho: Record<number, number>,
): void {
  const atual = lerRascunho(eventoId);
  gravar(eventoId, { ...atual, qtd: { ...carrinho } });
}

/** Nome e WhatsApp digitados na janela de pagamento. */
export function guardarDadosContato(
  eventoId: number | string,
  nome: string,
  whatsapp: string,
): void {
  const atual = lerRascunho(eventoId);
  gravar(eventoId, { ...atual, nome, whatsapp });
}

/** Pedido criado com sucesso: esquece tudo deste evento neste aparelho. */
export function limparRascunho(eventoId: number | string): void {
  try {
    sessionStorage.removeItem(chaveRascunho(eventoId));
  } catch {
    // ignorado
  }
}